/**
 * NotFound — the only surviving placeholder page.
 *
 * Every other placeholder was replaced by a real implementation and the dead
 * exports were pruned (S-141); the catch-all 404 route still renders this.
 */

import { useTranslation } from "@/hooks/useTranslation";

export function NotFound() {
  const { t } = useTranslation();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: "var(--bg-page)",
        gap: "16px",
      }}
    >
      <span
        style={{
          fontSize: "64px",
          fontFamily: "'JetBrains Mono', monospace",
          fontWeight: 500,
          color: "var(--text-muted)",
        }}
      >
        404
      </span>
      <p style={{ fontSize: "14px", color: "var(--text-secondary)" }}>{t("errors.pageNotFound")}</p>
      <a
        href="/dashboard"
        style={{ fontSize: "14px", color: "var(--accent)", textDecoration: "underline" }}
      >
        {t("common.goToDashboard")}
      </a>
    </div>
  );
}
